import { render, staticRenderFns } from "./rankings.vue?vue&type=template&id=704eba10&scoped=true&"
import script from "./rankings.vue?vue&type=script&lang=js&"
export * from "./rankings.vue?vue&type=script&lang=js&"
import style0 from "./rankings.vue?vue&type=style&index=0&id=704eba10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704eba10",
  null
  
)

export default component.exports